import { render, staticRenderFns } from "./UserNavigationMenu.vue?vue&type=template&id=26530643&scoped=true"
import script from "./UserNavigationMenu.vue?vue&type=script&lang=js"
export * from "./UserNavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./UserNavigationMenu.vue?vue&type=style&index=0&id=26530643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26530643",
  null
  
)

export default component.exports